import $ from 'jquery';
import formatGrid from './formatGrid';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatGrid(`[data-section-id="${e.detail.sectionId}"]`);
  });
};